/** @jsxImportSource @emotion/react */
import Text from 'src/components/ts-components/Text'
import colors from '@sportninja/common/constants/appColors'
import { scoreStyles, winnerBarStyles } from '../styles'

interface ScoreDisplayProps {
  score: number | string
  isWinner: boolean
}

const ScoreDisplay = ({ score, isWinner }: ScoreDisplayProps) => {
  return (
    <div css={scoreStyles}>
      <Text
        variant='displaySmall'
        weight='semiBold'
        color={colors.NEUTRAL_0}
        style='line-height: 48px;'
      >
        {score}
      </Text>
      {isWinner && <div css={winnerBarStyles} />}
    </div>
  )
}

export default ScoreDisplay
